<template>
  <video width="100%" height="240" controls controlsList="nodownload">
    <source :src="src"
            type="video/mp4">
    Your browser does not support the video tag.
  </video>
</template>

<script>
export default {
  props: ['src']
}
</script>

<style>
  video {
    outline: none;
  }
</style>
